'use client'

import { getEnv } from "@/lib/getEnv";
import Script from "next/script";
import { useEffect, useState } from "react";

export function AdobeTag() {

  // At the moment cookie is not set up properly so when we we have
  // a live production cookie we can work on this logic to load any tag we want
  // Please refer to the UWL project AdobeTag.tsx for the logic

  // Todo: check if the cookie is set up properly

  const [env, setEnv] = useState<'dev' | 'staging' | 'live' | null>(null)
  const [cookiesAccepted, setCookiesAccepted] = useState<undefined | boolean>(undefined)
  const [check, setCheck] = useState(0)

  const fetchCookies = async () => {
    const res = await fetch('/cookies')
    const cookies = await res.json()

    if ('OptanonConsent' in cookies && !cookies.OptanonConsent.includes('interactionCount=0')) {
      if (cookies.OptanonAlertBoxClosed) {
        setCookiesAccepted(true)
      } else {
        setCookiesAccepted(false)
      }
    }
  }

  useEffect(() => {
    setEnv(getEnv())
    if (cookiesAccepted === undefined) {
      const id = setInterval(() => {
        fetchCookies()
        setCheck(check + 1)
      }, 3000)
      return () => clearInterval(id)
    }

  }, [check, cookiesAccepted])

  if (env === 'staging' && cookiesAccepted) {
    return <Script src="https://assets.adobedtm.com/a2ef59fba8e9/7f6d378ecd1a/launch-bbc1affd862a-staging.min.js" async />
  } else if (env === 'live' && cookiesAccepted) {
    return <Script src="https://assets.adobedtm.com/a2ef59fba8e9/7f6d378ecd1a/launch-2ef5cb9792e7.min.js" async />
  } else if (env === 'dev' && cookiesAccepted) {
    return <Script src="https://assets.adobedtm.com/a2ef59fba8e9/7f6d378ecd1a/launch-bbc1affd862a-staging.min.js" async />
  }

  return null
}